import isEqual from 'lodash/isEqual';
export function useIsChanged(...args) {
    return args.some(([source, state]) => typeof source !== typeof state || !isEqual(source, state));
}
